export default "__VITE_ASSET__CIHDi$PD__"